import React, { useEffect, useState } from "react";
import Meta from "./Meta";
import BlogCard from "./BlogCard.js";
import { Container, Grid,Box, Typography, Button, Modal } from "@material-ui/core";
import Section from "./Section";
import { Link } from 'react-router-dom';
import AddBox from "@material-ui/icons/AddBox";
import { useCardDataContext } from './CardDataContext.js';
  import { useAuth } from "../util/auth.js";
import {CircularProgress} from "@material-ui/core";
import { blogAdmins, blogUrl } from "../util/blogFeaturesSettings";
function BlogList(props) {
      document.title = 'Blogs NSFWartgenerator - Latest Blogs';
      const [cardData, setCardData] = useState([]);
      const [loading, setLoading] = useState(true);

     const {cardCount,blogMetaData,setBlogMetaData}=useCardDataContext();
     const auth = useAuth();


useEffect(() => {
  const fetchAllBlogInfo = async () => {
    try {
      setLoading(true);
console.log(blogUrl)
      // Make the API request
      const response = await fetch(`${blogUrl}/api/tasks`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Check if the request was successful (status code 200-299)
      if (!response.ok) {
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      // Parse the JSON response
      const data = await response.json();

      // Log or use the data as needed
      // console.log('Fetched Blog:', data);
      localStorage.setItem('cardCount',data.length );
 
      const newData = data.map(object => {
        return {
          title: object.title,
          description: object.description,
          createdTime: object.createdAt,
          id: object._id,
          imgSrc: object.coverImage,
          imgAlt: "Cover Image"
        };
      });
            // console.log("data filtered:" ,newData)

        // Extract relevant information for shared data
        const updatedMetaData = newData.map((object) => ({
          id: object.id,
          title: object.title,
          slugTitle: generateSlugTitle(object.title),
        }));
        setBlogMetaData(updatedMetaData);
      //  console.log(blogMetaData)

      setCardData(newData)
      // console.log("data filtered:" ,newData)


      // Set the fetched data in state
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }finally {
      setLoading(false);
    }
  };

  // Fetch data when the component mounts
  
  fetchAllBlogInfo();


}, [cardCount]); // Dependency array to re-run effect when props.id changes

useEffect(() => {
  // Log the blogMetaData
  // console.log("blog meta", blogMetaData);

  // Store the blogMetaData in local storage
  localStorage.setItem('blogMetaData', JSON.stringify(blogMetaData));
}, [blogMetaData]);

const generateSlugTitle = (title) => {
  // Logic to generate slugify title from the given title
  return title.toLowerCase().replace(/\s+/g, '-');
};




if (loading) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <CircularProgress />
    </div>
  );
}

  return (
    <>   <Typography
    variant="h4"
    align="center"
    sx={{
      margin: "1rem",
      padding: "0.5rem",
    }}
  >
    THE BLOGS
  </Typography>

  <Section>
    <Meta title="Blog Page" />
    <Container>
    {auth.user && blogAdmins.includes(auth.user.email) && (
 
 <Button variant="contained" style={{ background: "#6600FF", color: "white" }} component={Link} to={`/createBlog`}>
 <AddBox /> Add New Blog
</Button>
)}

      {cardData.length > 0 ? (
        <Grid container spacing={10} style={{ marginTop: "10px", background: "rgba(0, 0, 0, 0.17)" }}>
          {cardData.map((item, index) => (
            <Grid item key={index} xs={12} sm={6} md={4} style={{ margin: "0px" }}>
              <BlogCard
                id={item.id}
                imgSrc={item.imgSrc}
                imgAlt={item.imgAlt}
                title={item.title}
                description={item.description}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography
          variant="body1"
          align="center"
          sx={{
            margin: "2rem",
            padding: "1rem",
          }}
        >
          New blogs will be updated soon.
        </Typography>
      )}
    </Container>
</Section>
</>

  );
}

export default BlogList;


